import React from "react";
import { PageNav } from "@ugg/shared/components/common/PageNav";
import { AppRoutes } from "@ugg/shared/routes/app-routes";

const SettingsNav = ({ isBoost }) => {
  const navLinks = [
    { label: "General", to: AppRoutes.SETTINGS_ACCOUNT },
    { label: "League of Legends", to: AppRoutes.SETTINGS_FILTER_PREFERENCES },
    { label: "PLUS", to: AppRoutes.SETTINGS_PLUS },
    ...(isBoost ? [{ label: "BOOST", to: AppRoutes.SETTINGS_BOOST }] : []),
  ];

  return <PageNav tabs={navLinks} />;
};

export default SettingsNav;
